<script>
import Tailwindcss from '../Tailwind.svelte'
  
import {itemC, container} from '../components/animations.js'
import {Button} from 'carbon-components-svelte';
import Tailwind from '../Tailwind.svelte';
import {Lottie} from 'lottie-svelte';
import {M} from 'svelte-motion'
import { sessionData } from '../stores';
import { getAuth, RecaptchaVerifier} from 'firebase/auth';
import {onMount} from 'svelte';


export let params = {};


</script>

<Tailwind/>
    



<div class="h-screen" style="display: grid;">
  {#if params.status == "success"}
        <div style="margin: auto" class="w-48">
      <Lottie loop={false} class="w-48" path="mobile_success.json" speed={1}/>
        </div>
        <h2 class="m-auto font-brown">Payment Successful</h2>
  {:else}
        <div class="m-auto w-48">
      <Lottie loop={false} class="w-48" path="mobile_failed.json" speed={1}/>
        <h2 class="m-auto font-brown">Payment failed</h2>
        </div>
  {/if} 

</div>


<style>



</style>

    



